var _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.21875,
    y: 0.0234375,
    width: 17.7808,
    height: 17.7808,
    rx: 4,
    fill: "#2CA58D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.58691,
    y: 1.3916,
    width: 15.0453,
    height: 15.0453,
    fill: "url(#pattern0_110_1568)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_110_1568",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_110_1568",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_110_1568",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADaElEQVR4nO3dT4hNYRjH8YNMIkr+5E8ZTTZSYqMpxcI0ESmL10IWRImU5SykZqHMQkopGws1i2FqrJSFWMmkZqMkFpo0ZZQSJpI/89WZOY2Ec+/MOfe8z/ue36fu+r7P+d1z5j7nveeZJBERERERMQNo970GSaaCmAdcBj4D+3VQPALagAF++wGc8Lmm2gKWAPf42yTQ43t9tQKsAIbJdxWY73ut0QM2Ai9pTj+w0PeaowVsAcaYnfvAUt9rjw6wC/jA3DwBVvquIRrAQeALxTwHNviuJXjAMeA75XgDbPVdU7CAnuxrbJneAzt91xZq990q6uoLdN+toq6+QPfdKunlsLfhwuqI5rrvVlFXX6D7bhV19QW671ZRVw90A66JV1HDTb7P5qlPiuQrIZDBBm8hs6FAjEFniC0KxBh0htgSbSDAquyW9k1gBHgHfMMGl7PuuAIBdgBDhg5+PQMB1gG3CYPLqSP8QIC92SUpFC6nlrADSX/Bl93zD4nLqSfcQIAjwE/C43JqCjMQoNP4H+76BJLtuI0SLpdTW5CBXCJsLqe2sALJtkAnCJuLKZDzhM/FFMgLwueiCAToIA4ulkCOEgcXSyAXiYOLJZAbxMHFEsgtyvMsu00/6OHVGUsgaTFFfQT2JUZRw0BOJ4ZRw0DWJoZRt0ASw4D1JQTSX+WCYw/kbAmBXK9ywdEGAhwo6abphSgCYXrDy8dX4KHsUeayHI4lEEccOhSIHaOVhaEzpClXFIgt2xWIHQ8qDUOXrIZ2KxA7BioPQ2fIf70F1igQG9JxTnu8hKEz5J/zS/yOilWnPiP9gfkZr2EokD92PA8lFugM4TGwKbGixoGMASfNDUyuWSCTwKPsCbG2xKKIA5kAxpm+JKW/PTsexKjXmHcMg6RAjFEgxigQYxSIMQqkIulAxiYHN5Yx77aZ9+lO6gxYDNzFhnFgW1J3wAIDD+S8MnWvyMh/C+jzFMYIsNr3MTAJOFfxUJmHwDLfdZuWPXFbxXCZO8Ai3/UGAegCPrUwjGvmbmlbl81QbMW0uD7ftYXep7wuKYh0+twp3zUFLxty+bRgGF/znhGXWQKWZ7toc90E6tJBt9HVq/s21NWr+66wq+9tEIa6b0NdvbpvQ129um9DXb26byuAdt9rEBERERFJZvwC4mENogDIknIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeUser);
export default __webpack_public_path__ + "static/media/change-user.33821ca5d24c110d04040e97ac63da32.svg";
export { ForwardRef as ReactComponent };